module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "dispatchLook"
    }
  }, [_c('el-col', {
    staticClass: "searthPart",
    staticStyle: {
      "width": "100%",
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "order-content"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('el-form', {
    staticClass: "demo-form-inline clearfix",
    attrs: {
      "inline": true,
      "model": _vm.orderForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "详细地址："
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入详细地址"
    },
    model: {
      value: (_vm.orderForm.address),
      callback: function($$v) {
        _vm.$set(_vm.orderForm, "address", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单号："
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入单号"
    },
    model: {
      value: (_vm.orderForm.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.orderForm, "orderNo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderForm.orderNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    },
    on: {
      "click": _vm.selectWorkOrder
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('i', {
    staticClass: "fr el-icon-refresh",
    staticStyle: {
      "font-size": "25px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    ref: "singleTable",
    staticClass: "siggle-select-content",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.returnData,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      },
      "highlight-current-row": ""
    },
    on: {
      "current-change": _vm.handleCurrentSingleChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox', {
          attrs: {
            "checked": scope.row.selected
          },
          on: {
            "change": function($event) {
              return _vm.handleCurrentSingleChange(scope.row)
            }
          },
          model: {
            value: (scope.row.selected),
            callback: function($$v) {
              _vm.$set(scope.row, "selected", $$v)
            },
            expression: "scope.row.selected"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "200",
      "label": "设备详情"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.modelName) + " " + _vm._s(scope.row.colorName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "100",
      "label": "订单类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("sysCodeFileter")(scope.row.serviceType, 'order_type')) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "align": "center",
      "label": "订单渠道"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("sysCodeFileter")(scope.row.orderIdentifier, 'order_identifier')) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "sortable": "",
      "label": "区域"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                       " + _vm._s(scope.row.countyName) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "200",
      "label": "地址"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.address) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "totalAp",
      "label": "故障小类"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.faultSubclass), function(item, index) {
          return _c('span', {
            key: index,
            staticStyle: {
              "display": "block"
            }
          }, [_vm._v(_vm._s(item.faultSubclassShortName))])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "预约时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.onsiteDate) + " " + _vm._s(scope.row.onsiteTimeStart) + "~" + _vm._s(scope.row.onsiteTimeEnd))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "220",
      "align": "center",
      "prop": "orderNo",
      "label": "订单号"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "engineerForm",
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.engineerForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "维修状态："
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择工程师维修状态",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.selectEngineerStatus
    },
    model: {
      value: (_vm.engineerForm.maintenceStatus),
      callback: function($$v) {
        _vm.$set(_vm.engineerForm, "maintenceStatus", $$v)
      },
      expression: "engineerForm.maintenceStatus"
    }
  }, _vm._l((_vm.pickingEngineerStatus), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "item-click-content"
  }, [_c('el-button', {
    class: {
      'active': _vm.engineerForm.isQueryMt == 1
    },
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.mtClick
    }
  }, [_vm._v("技能匹配")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "item-click-content"
  }, [_c('el-button', {
    class: {
      'active': _vm.engineerForm.isQueryPm == 1
    },
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.pmClick
    }
  }, [_vm._v("背包匹配")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fr",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-card', {
    staticClass: "box-card item-click-content"
  }, _vm._l((_vm.pickingEngineerList), function(item, index) {
    return _c('el-button', {
      key: index,
      class: {
        'active': item.isMatch == 1
      },
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.newModel(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dislogModel,
      "custom-class": "showTable",
      "close-on-click-modal": false,
      "width": "1100px",
      "modal-append-to-body": false,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogModel = $event
      },
      "close": _vm.emptyModelDialog
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "订单列表",
      "name": "first"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.engineerOrderList,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "100",
      "align": "center",
      "label": "订单渠道"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                                " + _vm._s(_vm._f("sysCodeFileter")(scope.row.orderIdentifier, 'order_identifier')) + "\n                            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "align": "center",
      "prop": "modelName",
      "label": "机型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "180",
      "label": "故障"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.faultSubclass), function(item, index) {
          return _c('span', {
            key: index,
            staticStyle: {
              "display": "block"
            }
          }, [_vm._v(_vm._s(item.faultSubclassShortName))])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "onsiteDate",
      "width": "100",
      "label": "预约日期"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "120",
      "label": "预约时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.onsiteTimeStart) + "~" + _vm._s(scope.row.onsiteTimeEnd))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "80",
      "label": "区域"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                                " + _vm._s(scope.row.countyName) + "\n                            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "150",
      "label": "地址"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                                " + _vm._s(scope.row.address) + "\n                            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "align": "center",
      "prop": "payTime",
      "label": "完成时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.payTime) ? _c('span', [_vm._v(_vm._s(_vm._f("date")(scope.row.payTime)))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "align": "center",
      "label": "完成度"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                                " + _vm._s(_vm._f("sysCodeFileter")(scope.row.adminStatus, 'admin_status')) + "\n                            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180",
      "align": "center",
      "prop": "orderNo",
      "label": "订单号"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "库存列表",
      "name": "second"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.engineerInventoryList,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "180",
      "align": "center",
      "prop": "modelName",
      "label": "型号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.modelName) + " " + _vm._s(scope.row.colorName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "180",
      "prop": "materialName",
      "label": "物料名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180",
      "align": "center",
      "prop": "materialCode",
      "label": "物料编码"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "warehouseType",
      "label": "仓库类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180",
      "align": "center",
      "prop": "name",
      "label": "工程师名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "sum2",
      "label": "数量"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.dislogModel = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-03f7045a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dispatchOrder/dispatchLook.vue
// module id = 1568
// module chunks = 0